import React from 'react'
import { Spin, Row, Col } from 'antd'
import NumberFormat from 'react-number-format'
import useUserDragonDetails from '../../hooks/useUserDragonDetails'
import { WarningOutlined } from '@ant-design/icons'

export default function DragonOwnerDetails(props) {

  const { accountAddress } = props
  const { userDragonDetails, isLoading: userDragonDetailsLoading } = useUserDragonDetails({ accountAddress })

  return (

    <div className='dragon-owner-dashboard-container'>
      <div className='dragon-owner-title'>
        Dragon Owner's Dashboard
      </div>

      <Row className='dragon-owner-statistic'>
        <Col xs={24} sm={12} md={6} lg={6} xl={6} className='mobile-top-margin px-2'>
          <div className='dragon-owner-data-container'>
            <div className='dragon-owner-data-title'>
              Initial Deposit
            </div>

            {
              userDragonDetailsLoading ? (
                <div className='loading-container'>
                  <Spin style={{ color: 'red' }} size="small" />
                </div>) : (
                <div className='dragon-owner-data-value'>
                  <NumberFormat
                    className='dragon-owner-data-field'
                    style={{ marginRight: '5px' }}
                    value={userDragonDetails ? userDragonDetails.initialDeposit : 0.00}
                    displayType="text"
                    decimalScale={3}
                    thousandSeparator={true}
                  />
                  <div className='value-suffix'>
                    BNB
                  </div>
                </div>
              )
            }

          </div>
        </Col>

        <Col xs={24} sm={12} md={6} lg={6} xl={6} className='mobile-top-margin px-2'>
          <div className='dragon-owner-data-container'>
            <div className='dragon-owner-data-title'>
              Total Deposit
            </div>

            {
              userDragonDetailsLoading ? (
                <div className='loading-container'>
                  <Spin style={{ color: 'red' }} size="small" />
                </div>) : (
                <div className='dragon-owner-data-value'>
                  <NumberFormat
                    className='dragon-owner-data-field'
                    style={{ marginRight: '5px' }}
                    value={userDragonDetails ? userDragonDetails.userDeposit : 0.00}
                    displayType="text"
                    decimalScale={3}
                    thousandSeparator={true}
                  />
                  <div className='value-suffix'>
                    BNB
                  </div>
                </div>
              )
            }


          </div>
        </Col>

        <Col xs={24} sm={12} md={6} lg={6} xl={6} className='mobile-top-margin px-2'>
          <div className='dragon-owner-data-container'>
            <div className='dragon-owner-data-title'>
              Withdrawn
            </div>

            {
              userDragonDetailsLoading ? (
                <div className='loading-container'>
                  <Spin style={{ color: 'red' }} size="small" />
                </div>) : (

                <div className='dragon-owner-data-value'>
                  <NumberFormat
                    className='dragon-owner-data-field'
                    style={{ marginRight: '5px' }}
                    value={userDragonDetails ? userDragonDetails.totalWithdrawn : 0.00}
                    displayType="text"
                    decimalScale={3}
                    thousandSeparator={true}
                  />
                  <div className='value-suffix'>
                    BNB
                  </div>
                </div>
              )
            }
          </div>
        </Col>

        <Col xs={24} sm={12} md={6} lg={6} xl={6} className='mobile-top-margin px-2'>
          <div className='dragon-owner-data-container'>
            <div className='dragon-owner-data-title'>
              Referrals
            </div>

            {
              userDragonDetailsLoading ? (
                <div className='loading-container'>
                  <Spin style={{ color: 'red' }} size="small" />
                </div>) : (
                <div className='dragon-owner-data-value'>
                  <NumberFormat
                    className='dragon-owner-data-field'
                    style={{ marginRight: '5px' }}
                    value={userDragonDetails ? userDragonDetails.referralEggRewards : 0.00}
                    displayType="text"
                    decimalScale={3}
                    thousandSeparator={true}
                  />
                  <div className='value-suffix'>
                    BNB
                  </div>
                </div>
              )
            }

          </div>
        </Col>
      </Row>

      <Row className='mt-4 dragon-owner-disclaimer-section'>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div className='disclaimer-container'>
            <div className='disclaimer-title'>
              <WarningOutlined /> Disclaimer
            </div>
            <div className='disclaimer-value'>
              Funds that are used to initially hire dragons (including re-hire) cannot be withdrawn, however your dragons will indefinitely work and fight for you. Please use the application at your own risk.
            </div>
          </div>
        </Col>
      </Row>

    </div>

  )
}
